<template>
  <div id="manage-list">
    <table-header-search-vue
      @onShowAdd="handleOpenCreate"
      @onShowDelete="handleOpenDelete"
      @onSearchTableItem="handleSearchUser"
      :deleteList="deleteUsers"
    />
    <table-vue
      :columns="columns"
      :tableData="userList"
      :controllers="controllers"
      @onSelectItem="handleSelectItem"
      @onEditUser="handleEditUser"
      @onControllerChange="handleRoleControllerChange"
      @onChangeSort="handleChandleSort"
    />
    <table-footer-pagination-vue
      @onChangePage="handleChangePage"
      @onChangePageSize="handleChangePageSize"
      :totalNum="totalNum"
    />

    <!-- 创建用户账号弹窗 -->
    <manage-create-user-vue
      v-model="showCreateUser"
      @OnUpdateListByAdd="handleUpdateByAdd"
      :roleList="roleList"
      v-if="roleList[0]"
    />

    <!-- 编辑用户账号弹窗 -->
    <manage-edit-user-vue
      v-model="showEditUser"
      v-if="roleList[0]"
      :roleList="roleList"
      :editUserPassword="editUserInfo.password"
      :editUserNickName="editUserInfo.nickName"
      :editUserRoleList="editUserRoleList"
      :editUserUid="editUserInfo.uid"
      :editUserNumber="editUserInfo.userNumber"
      @onConfirmEdit="handleConfirmEdit"
      @onCancelEdit="handleCancelEdit"
    />
    <!-- 删除确认弹窗 -->
    <confirm-delete-popup-vue
      v-if="showDeletePopup"
      @onConfirmDelete="handleDeleteUser"
      @onCancelDelete="handleCancelDelete"
    />
  </div>
</template>

<script>
import tableHeaderSearchVue from '../../components/layout/table-header-search.vue';
import tableFooterPaginationVue from '../../components/layout/table-footer-pagination.vue';
import tableVue from '../../components/layout/table.vue';
import { manageListTable } from '../../components/manage/manage-list-table';
import manageCreateUserVue from '../../components/manage/manage-create-user.vue';
import manageEditUserVue from '../../components/manage/manage-edit-user.vue';
import { ROLE_TYPE } from '../../config/constant';
import { searchUser, batchDeleteUser, getUserList } from '../../api/index';
import confirmDeletePopupVue from '../../components/layout/confirm-delete-popup.vue';
import { mapGetters } from 'vuex';
import { Controller } from 'swiper';
import { roleJudge } from '../../config/roleJudge';

export default {
  name: 'ManageList',
  components: {
    tableHeaderSearchVue,
    tableFooterPaginationVue,
    tableVue,
    manageCreateUserVue,
    manageEditUserVue,
    confirmDeletePopupVue
  },
  data() {
    return {
      roleList: [],
      columns: manageListTable,
      userList: [],
      showCreateUser: false, //用于显示创建弹窗
      showEditUser: false, //用于显示编辑用户弹窗
      showDeletePopup: false,
      controllers: {
        roleName: {
          list: ROLE_TYPE,
          value: ''
        }
      },
      deleteUsers: [], //保存选择删除出来的用户
      deleteUsersUid: [], //保存要删除用户的uid
      editUserInfo: '', //保存准备编辑的用户对象
      editUserRoleList: [], //保存准备编辑的用户的角色
      totalNum: 0, //分页总条数
      page: 1,
      pageSize: 20,
      authorizationLimit: false //控制用户权限
    };
  },
  computed: {
    ...mapGetters('login', ['userInfo'])
  },
  created() {
    this.initUserList();
    getUserList().then(res => {
      if (res.data.code == 200) {
        this.roleList = res.data.data;
      }
    });
  },
  methods: {
    /**
     * 初始化用户列表
     */
    initUserList(searchStr) {
      searchUser(searchStr).then(res => {
        if (res.data.code == 200) {
          const data = res.data.data.userList;
          const message = res.data.message;
          this.totalNum = res.data.data.total;
          data.forEach(e => {
            let roleName = [];
            e.userUserRoleList.forEach(e => {
              // roleName = roleName + e.roleName + ' ';
              roleName.push(e.roleName);
            });
            e.roleName = roleName.join(',');
          });

          this.userList = data;
        }
      });
    },
    /**
     * 打开创建用户弹窗
     */
    handleOpenCreate(showAdd) {
      this.showCreateUser = showAdd;
      // this.showCreateUser = showAdd;
    },

    /**
     * 打开编辑用户弹窗
     */
    handleOpenEdit() {
      this.showEditUser = true;
    },
    /**
     * 显示删除确认弹窗
     */
    handleOpenDelete(showDelete) {
      const demo = this.deleteUsers.some(e => {
        return e.userUserRoleList.some(e => {
          return e.roleType == 1;
        });
      });
      if (demo) {
        this.$message({
          type: '',
          message: '禁止删除管理员',
          offset: 72,
          center: true,
          duration: 800,
          customClass: 'attribute-delete-message'
        });
      } else {
        if (this.deleteUsers[0]) {
          this.showDeletePopup = showDelete;
        }
      }
    },

    /**
     * 监听添加用户刷新列表
     */
    handleUpdateByAdd() {
      this.initUserList();
    },

    /**
     * 监听选中表格项回调
     */
    handleSelectItem(itemList) {
      this.deleteUsers = itemList;
    },
    /**
     * 监听删除用户回调
     */
    handleDeleteUser() {
      this.deleteUsers.forEach(e => {
        if (e.uid != this.userInfo.uid) {
          this.deleteUsersUid.push(e.uid);
        }
      });
      this.deleteUsersUid = Array.from(new Set(this.deleteUsersUid));
      batchDeleteUser(this.deleteUsersUid).then(res => {
        if (res.data.code == 200) {
          this.showDeletePopup = false;
          // this.page = this.page === 1 ? this.page : this.page - 1;
          const pageNum = Math.ceil(this.totalNum / this.pageSize);
          const deletedPageNum = Math.ceil(
            (this.totalNum - this.deleteUsersUid.length) / this.pageSize
          );
          this.page =
            this.page === pageNum && pageNum > deletedPageNum && this.page != 1
              ? this.page - 1
              : this.page;
          this.initUserList({
            roleType: this.roleType,
            page: this.page,
            pageSize: this.pageSize
          });
          this.deleteUsersUid = [];
          this.$prompt('删除成功');
        } else {
          this.$prompt('删除失败');
        }
      });
    },

    /**
     * 取消删除回调
     */
    handleCancelDelete() {
      this.showDeletePopup = false;
      this.deleteUsersUid = [];
    },

    /**
     * 监听搜索回调
     */
    handleSearchUser(searchKeyWords) {
      this.initUserList({ searchStr: searchKeyWords, roleType: this.roleType });
    },

    /**
     * 编辑列表用户信息回调
     */
    handleEditUser(row) {
      this.editUserInfo = row;
      this.editUserRoleList.splice(0, this.editUserRoleList.length);
      row.userUserRoleList.forEach(e => {
        this.editUserRoleList.push(e.roleUid);
      });
      this.showEditUser = true;
    },

    /**
     * 确认编辑回调
     */
    handleConfirmEdit() {
      this.initUserList({ roleType: this.roleType });
      this.editUserRoleList = [];
    },

    /**
     * 取消编辑回调
     */
    handleCancelEdit() {
      this.editUserRoleList = [];
    },

    /**
     * 监听页码回调
     */
    handleChangePageSize(pageSize) {
      this.pageSize = pageSize;
      this.initUserList({ roleType: this.roleType, pageSize, page: this.page });
    },

    /**
     * 监听页条目数回调
     */
    handleChangePage(page) {
      this.page = page;
      this.initUserList({
        roleType: this.roleType,
        page,
        pageSize: this.pageSize
      });
    },
    /**
     * 监听角色筛选器回调
     */
    handleRoleControllerChange(controller) {
      const roleType = controller.value;
      this.roleType = controller.value;

      if (roleType) {
        searchUser({ roleType }).then(res => {
          if (res.data.code == 200) {
            const data = res.data.data.userList;
            const message = res.data.message;
            this.totalNum = res.data.data.total;
            data.forEach(e => {
              const item = e.userUserRoleList.find(e => {
                return e.roleType == roleType;
              });
              e.roleName = item.roleName;
            });

            this.userList = data;
          }
        });
      } else {
        this.initUserList();
      }
    },

    /**
     *监听排序回调
     */
    handleChandleSort(sortType, sortParam) {
      sortType = Number(sortType);
      this.initUserList({ sortType, sortParam, roleType: this.roleType });
    }
  }
};
</script>

<style lang="scss">
#manage-list {
  .icon-bianji {
    font-size: 25px !important;
    color: $color-primary;
    font-weight: 800;
  }
}
</style>
